import yxpapi from '@/extlib/yxpapi';
import config from '@/config';
import { configAccess } from '@/lib/functional';
import index from '@/components/pageManage/mobile/index';
import content from '@/components/pageManage/mobile/content';
import mobileBox from '@/components/pageManage/mobile/mobileBox';
import mobileContent from '@/components/pageManage/mobile/mobileContent';
import webModulePage from '@/components/pageManage/webModule/webModulePage';
import web003 from '../components/pageManage/webModule/web003/router';
import api from '@/components/pageManage/webModule/proxy.js';
// import contentManage from '@/components/pageFront/contentManage/router';

const stroage = yxpapi.stroage;
/* 404指向 */
const TransferStation = () => import(/* webpackChunkName: "web-portal" */ '@/components/common/TransferStation');
const TheError = () => import(/* webpackChunkName: "web-portal" */ '@/components/common/TheError');
const WebPortal = () => import(/* webpackChunkName: "web-portal" */ '@/components/common/WebPortal'); // 一级路由 WebPortal
let router = new window.VueRouter({
        routes: [
            {
                name: 'transfer',
                path: '/transfer',
                component: TransferStation,
                meta: {
                    disableValidation: true,
                },
            },
            {
                path: '/mobile',
                name: 'mobile',
                component: index,
                meta: {
                    keepAlive: true,
                    disableValidation: true,
                },
            },
            {
                path: '/mobileContent',
                name: 'mobileContent',
                component: content,
                meta: {
                    disableValidation: true,
                },
            },
            {
                path: '/mobileModules',
                name: 'mobileModules',
                component: mobileBox,
                meta: {
                    disableValidation: true,
                },
            },
            {
                path: '/mobileBoxContent',
                name: 'mobileBoxContent',
                component: mobileContent,
                meta: {
                    disableValidation: true,
                },
            },
            {
                path: '/webModulePage',
                name: 'webModulePage',
                component: webModulePage,
                meta: {
                    disableValidation: true,
                },
                children: [
                    ...web003,
                ],
            },
            // ...contentManage,
            ...config.myRouter.filter(r => (r.meta && r.meta.root && r.meta.disableValidation)),
        ],
        scrollBehavior (to, from, savedPosition) {
            return { x: 0, y: 0 };
        },
    }),
    store = yxpapi.store;

router.beforeEach(async (to, from, next) => {
    let routerStatus = store.state.system.routerStatus,
        appList = store.getters['permission/appList'],
        loggingStatus = store.getters['global/isLogin'],
        permission = store.getters['system/permission'],
        clientPermission = store.getters['system/clientPermission'],
        isTransfer = ['transfer'].includes(to.name),
        disableValidation = to.meta.disableValidation,
        /* 必须登录的条件 */
        mustLogin = !disableValidation && (!!to.query.userToken || !loggingStatus || !appList);
    if (disableValidation) {
        if ((to.path === '/webModulePage' || to.path === '/mobile') && (from.path === '/' || from.path === '/mobile' || from.path === '/webModulePage')) {
            if (to.query.noLogin) {
                next();
            } else {
                let isLogin = 1;
                if (to.query.code) {
                    let res = await api.getSiteByCode({
                        code: to.query.code,
                    });
                    isLogin = res.data.isLogin;
                    if (isLogin) {
                        sessionStorage.setItem('urlSiteId', res.data.id);
                    }
                } else {
                    let siteId = to.query.siteId;
                    if (!siteId || siteId === 'undefined') {
                        siteId = sessionStorage.getItem('urlSiteId') || store.getters['system/getSiteList'][0].siteId;
                    }
                    console.log('siteId', siteId);
                    let res = await api.websiteInfo({
                        siteId,
                    });
                    isLogin = res.data.value.isLogin;
                }
                if (isLogin) {
                    store.commit('system/mu_appId', config.appId);
                    if (loggingStatus) {
                        next();
                        return;
                    }
                    sessionStorage.setItem('webModulePagePath', to.fullPath);
                    console.log('bbbbbbbbbbbbbbb', to.fullPath);
                    next({
                        fullPath: '/transfer',
                        path: '/transfer',
                        name: 'transfer',
                        query: Object.assign({}, to.query, { backPath: to.path }),
                        replace: true,

                    });
                } else {
                    next();
                }
            }
        } else {
            next();
        }
    } else {
        if (mustLogin) {
            // 未登录或者强制重新登录
            store.dispatch('system/act_clearAccount');
            store.commit('system/mu_appId', config.appId);
            if (loggingStatus) {
                window.location.reload();
                return;
            }
            next({
                fullPath: '/transfer',
                path: '/transfer',
                name: 'transfer',
                query: Object.assign({}, to.query, {
                    backPath: to.path,
                }),
                replace: true,

            });
            return;
        } else if (!isTransfer) {
            if (config.appId === 42) {
                next();
            } else if (stroage.persistent.get('system.yxpAppId') !== config.appId) { /* 判断appId是否一致，若不一致，需要重新获取权限 */
                // 访问其他应用时，重置路由和权限
                let query = {
                    userToken: store.getters['global/loginInfo'].jwtRefresh,
                    uuid: store.getters['global/currentOrg'].uuid,
                    toQuery: JSON.stringify(to.query),
                };
                store.dispatch('system/act_clearAccount');
                store.commit('system/mu_appId', config.appId);
                window.ELEMENT.Loading.service({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                });
                setTimeout(() => {
                    yxpapi.stroage.session.set('yxp-reolad', 1);
                    next(Object.assign({}, to, {
                        query: Object.assign({}, query),
                        replace: true,
                    }));
                }, 500);
                return;
            }
        }
        if (loggingStatus) {
            /* 若登录成功, 首次进入时需配置路由 */
            if (routerStatus === 'not-set' && !isTransfer) {
                if (Array.isArray(appList)) {
                    store.commit('system/mu_appId', config.appId);
                    let { orgType, orgId, identity: { identityId } = {} } = store.getters['global/currentOrg'],
                        plainRouter = [],
                        rootRouter = [],
                        allRouter = null;
                    let currentApp = store.getters['system/currentApp'];
                    if (currentApp.appId !== undefined) {
                        plainRouter = configAccess(config.myRouter.filter(r => !(r.meta && r.meta.root)), store.getters['system/access'], { orgId, orgType, identityId });
                        rootRouter = configAccess(config.myRouter.filter(r => (r.meta && r.meta.root && !r.meta.disableValidation)), store.getters['system/access'], { orgId, orgType, identityId });
                    }
                    allRouter = [...plainRouter, ...rootRouter];
                    if (allRouter.length < 1 || (allRouter[0].children && allRouter[0].children.length < 1)) {
                        window.ELEMENT.Message({
                            type: 'error',
                            duration: process.env.NODE_ENV === 'development' ? 0 : 1500,
                            showClose: true,
                            message: '对不起，您暂时没有访问权限！',
                            onClose () {
                                if (process.env.NODE_ENV === 'development') {
                                    store.dispatch('system/act_login_off', {
                                        backUrl: location.origin + location.pathname,
                                        path: '/',
                                    });
                                } else {
                                    store.dispatch('system/act_backToIndex');
                                }
                            },
                        });
                        return;
                    }
                    store.commit('system/mu_routerList', allRouter);
                    router.addRoutes([
                        {
                            path: '/',
                            component: WebPortal,
                            name: 'WebPortal',
                            redirect: store.getters['system/redirection'],
                            meta: {
                                disableValidation: true,
                            },
                            children: plainRouter,
                        },
                        ...rootRouter,
                        /* 404路由放最后面 */
                        {
                            name: '404',
                            path: '/*',
                            component: TheError,
                        },
                    ]);
                    next({ ...to, replace: true });
                    return;
                } else {
                    store.dispatch('system/act_login_off', {
                        backUrl: location.origin + location.pathname,
                        path: '/',
                    });
                }
            } else if (isTransfer) {
                store.dispatch('system/act_login_off', {
                    backUrl: location.origin + location.pathname,
                    path: '/',
                });
            } else if (!permission && !clientPermission) { // 登录成功，但没权限
                next({
                    path: '/transfer',
                    replace: true,
                });
                return;
            }
        }
        /* 验证登录 */
        // to.meta.disableValidation === true 禁用登录权限验证
        if (!disableValidation && !loggingStatus && !isTransfer) {
            next({
                path: '/transfer',
                replace: true,
            });
            return;
        }
        if (to.name === '404') {
            next({
                path: '/',
                replace: true,
            });
            return;
        }
        next();
    }
});
export default router;
